import gql from 'graphql-tag';

export default gql`
    mutation generateDietMutation($request: DietJoInputType) {
        me {
            dietGenerate(request: $request) {
                __typename
                ... on UnauthorizedException {
                    code
                }
                ... on ValidationException {
                    code
                    messages
                    details {
                        fieldName
                        messages
                    }
                }
                ... on BasicMutationSuccess {
                    code
                }
            }
        }
    }
`;
